import { Badge } from "../../ui/badge";

interface StatusBadgeProps {
  status: "scheduled" | "completed" | "declined";
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const variants = {
    scheduled: "bg-yellow-100 text-yellow-800",
    completed: "bg-green-100 text-green-800",
    declined: "bg-red-100 text-red-800",
  };

  const darkVariants = {
    scheduled: "bg-yellow-500",
    completed: "bg-green-500",
    declined: "bg-red-500",
  };

  const borderVariants = {
    scheduled: "border-yellow-500",
    completed: "border-green-500",
    declined: "border-red-500",
  };

  const labels = {
    scheduled: "Scheduled",
    completed: "Completed",
    declined: "Declined",
  };

  return (
    <Badge className={`${variants[status]} flex items-center gap-4 justify-start w-[98px] border ${borderVariants[status]}`}>
      <div className={`h-2 w-2 ${darkVariants[status]} rounded-full`}></div>
      {labels[status]}
    </Badge>
  );
}
